<template>

    <div id="lt_more_items">
      <div id="items_list">
        <CatalogItem :item="item" @play="play" @open_widget="widget_item=item" v-for="item in items" :key="item" />
      </div>
    </div>
</template>

<script>
import CatalogItem from '../catalog/item.vue';

export default {
  props: ["item"],
  components: { CatalogItem},
  data(){
    return {
        items: []
    }
  },
  methods: {

  },
  mounted(){
    // LOAD ITEMS
    var self = this;
    this.api({ action: 'vod/results', data: { lecturer: this.item.artist.id, limit:5 }}, function(data){ 
        self.items = data.data.items;
    });
  }
}
</script>

<style lang="scss" >
#lt_more_items {

  #items_list{display: flex;flex-wrap: wrap;gap: 10px;}

  .item { 
        & { display: block; margin-bottom: 25px; width: calc(50% - 10px); }
        .pic { padding-bottom: 100% !important;  }
        .play_btn { display: none;}
    }
}
</style>